<template>
  <main
    :class="['game-detail-mobile', gameName, region]"
    :style="pageBackgroundColor"
  >
    <MobileHeader ref="header" />
    <main class="detail-content">
      <GameCodeHeaderTips />
      <DetailsUidComponent />
      <NEWPackTemplate />
      <NEWReinforcePayment />
      <!-- <ClientDrainage v-if="isRenderAppBanner && !isApp" entry="details" /> -->
      <BottomTips v-if="!isApp" />
      <FooterButton v-if="!isApp" />
    </main>
    <PublicFooter :page="gameName" theme="light" />
    <NEWSubmitBtn />
    <ActivityNotice />
    <!-- 云原神 也不展示 -->
    <CouponEntryForNotLogged :page="gameName" />
    <FissionPopup v-if="!isGetapps && !isIAP" :page="gameName" />
    <RankingPopup :gameName="gameName" />
    <PubgmMask />
  </main>
</template>
<script>
  import BottomTips from '../components/BottomTips'
  import NEWSubmitBtn from '../components/NEWSubmitBtn'
  import NEWReinforcePayment from '../components/NEWReinforcePayment'
  import PublicFooter from '@/components/PublicFooter'
  import FooterButton from '@/components/FooterButton'
  import ActivityNotice from '../components/ActivityNotice'
  import GameCodeHeaderTips from '../components/GameCodeHeaderTips'
  import CouponEntryForNotLogged from '@/components/CouponEntryForNotLogged'
  import FissionPopup from '@/pages/Activity/Fission/Popups'
  import RankingPopup from '@/pages/Activity/Ranking/Home/popup'
  // import ClientDrainage from '@/components/ClientDrainage'
  import NEWPackTemplate from '@/components/NEWPackTemplate'
  import DetailsUidComponent from '@/components/DetailsUidComponent'
  import PubgmMask from '../components/PubgmMask'
  import { MobileHeader } from '../components/header'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'gameMobile', // 移动端游戏详情页
    props: {},
    components: {
      MobileHeader,
      // ClientDrainage,
      // MBPopover,
      // SkuTipsPopover,
      // IdSection,
      // PackageList,
      BottomTips,
      // SubmitBtn,
      PublicFooter,
      FooterButton,
      // FoldSwitch,
      ActivityNotice,
      GameCodeHeaderTips,
      CouponEntryForNotLogged,
      // IdCheck,
      FissionPopup,
      RankingPopup,
      NEWReinforcePayment,
      NEWPackTemplate,
      DetailsUidComponent,
      PubgmMask,
      NEWSubmitBtn,
    },
    data() {
      return {
        showPopover: false,
        displayPaymentMode: false,
      }
    },
    computed: {
      ...mapState(['gameName', 'region', 'isApp', 'isIAP', 'isGetapps']),
      ...mapGetters(['isRenderAppBanner']),
      pageBackgroundColor() {
        const backgroundColor = this.$__GAME__?.pageBackgroundColor || ''
        return {
          backgroundColor,
        }
      },
    },
    mounted() {
      document.body.setAttribute('class', `${this.gameName}`)

      window.addEventListener('orientationchange', this.reload)
    },
    beforeDestroy() {
      window.removeEventListener('orientationchange', this.reload)
    },
    methods: {
      reload() {
        window.location.reload()
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss" src="./common.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index.scss';
    @import './common.scss';
  }
</style>
